import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ConfigureSsoPanelFieldNames } from '../useConfigureSsoPanelForm';
import { SsoIdentityProviderField } from './SsoIdentityProviderField';

export interface ConfigureSsoPanelIdentityFieldsProps {
    canSelectIdentityProvider?: boolean;
}

export function ConfigureSsoPanelIdentityFields({
    canSelectIdentityProvider = true,
}: ConfigureSsoPanelIdentityFieldsProps) {
    return (
        <>
            <SsoIdentityProviderField
                name={ConfigureSsoPanelFieldNames.IdentityProvider}
                disabled={!canSelectIdentityProvider}
            />
            <FormInputField
                name={ConfigureSsoPanelFieldNames.IdpDomain}
                label={<LocalizedText textKey={TextKey.SsoSetupIdpDomain} />}
                size="medium"
                required
            />
            <FormInputField
                name={ConfigureSsoPanelFieldNames.ClientId}
                label={<LocalizedText textKey={TextKey.ClientId} />}
                size="medium"
                required
            />
        </>
    );
}
